module.exports = {
  version: 'Речевая аналитика U-Speech Analytics v.2.7',
  versionMtc: 'Речевая аналитика v.2.7',
  copyright: '© «ЮКИТЕХ ЛАБ» ',
  copyrightCallTraffic: '© «CallTraffic» ',
  copyrightMtc: '© MTC Exolve ',
};
